module.exports = __webpack_public_path__ + "static/img/employee.52a359a8.svg";